import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import gftAPP from '@/views/gftAPP'
import hot from '@/views/hot'
import clientDownload from '@/views/clientDownload'

//解决vue-router重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/gftAPP',
      name: 'gftAPP',
      component: gftAPP
    },
    {
      path: '/hot',
      name: 'hot',
      component: hot
    },
    {
      path: '/clientDownload',
      name: 'clientDownload',
      component: clientDownload
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js